"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScenarioStatisticShortcut;
(function (ScenarioStatisticShortcut) {
    ScenarioStatisticShortcut["fund"] = "fund";
    ScenarioStatisticShortcut["funds"] = "funds";
    ScenarioStatisticShortcut["portfolio"] = "portfolio";
    ScenarioStatisticShortcut["portfolios"] = "portfolios";
    ScenarioStatisticShortcut["portfoliosBarChartData"] = "portfoliosBarChartData";
    ScenarioStatisticShortcut["portfoliosMptStatistics"] = "portfoliosMptStatistics";
    ScenarioStatisticShortcut["portfolioCompositeFund"] = "portfolioCompositeFund";
    ScenarioStatisticShortcut["portfolioCorrelation"] = "portfolioCorrelation";
    ScenarioStatisticShortcut["entityRisksTable"] = "entityRisksTable";
    ScenarioStatisticShortcut["portfoliosScatterChartData"] = "portfoliosScatterChartData";
})(ScenarioStatisticShortcut = exports.ScenarioStatisticShortcut || (exports.ScenarioStatisticShortcut = {}));
//# sourceMappingURL=ScenarioStatisticShortcut.js.map